import script from "./BenchmarkCreatePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BenchmarkCreatePopup.vue?vue&type=script&setup=true&lang=js"

import "./BenchmarkCreatePopup.vue?vue&type=style&index=0&id=55822ad7&scoped=true&lang=css"

import exportComponent from "/Users/uguraslan/work/ljs/tools/strike/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55822ad7"]])

export default __exports__